/* Import Local Modules */
import RingTag from "./RingTag.js";
import CancelRingTag from "./CancelRingTag.js";
export default {
  install: molten => {
    molten.addPlugin('Action', RingTag);
    molten.addPlugin('Action', CancelRingTag);
  }
};